import { createSlice } from '@reduxjs/toolkit';
import { findIndex, get } from 'lodash-es';
const initialState = {};
export const alertsSlice = createSlice({
    name: 'form-alerts',
    initialState,
    reducers: {
        enqueueFormAlert: (state, action) => {
            const { form, alert: payloadAlert } = action.payload;
            const alert = Object.assign({ key: new Date().getTime() + Math.random() }, payloadAlert);
            state[form] = [...get(state, form, []), alert];
        },
        removeFormAlert: (state, action) => {
            const { form, key } = action.payload;
            const index = findIndex(state[form], { key: `${key}` });
            if (-1 !== index) {
                delete state[form][index];
            }
        },
        clearFormAlerts: (state, action) => {
            const { form } = action.payload;
            state[form] = [];
        },
    },
});
export const { enqueueFormAlert, removeFormAlert, clearFormAlerts } = alertsSlice.actions;
export default alertsSlice.reducer;
